import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSquareLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2485_55047)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 10,
			fill: "#FF771C"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M20.0574 12H11.9431C9.39148 12 7.47754 13.4682 7.47754 15.9619C7.47754 18.4557 9.35182 20 11.9431 20H20.0574C22.6487 20 24.5229 18.5009 24.5229 15.9619C24.5229 13.423 22.6098 12 20.0574 12ZM19.7401 18.8689H12.2604C10.8374 18.8689 9.38038 17.8743 9.38038 15.9778C9.38038 14.0813 10.8382 13.1327 12.2604 13.1327H19.7401C21.163 13.1327 22.6201 14.1114 22.6201 15.9778C22.6201 17.8441 21.1623 18.8689 19.7401 18.8689Z",
			fill: "black"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2485_55047",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 10,
			fill: "white"
		})
	}) })]
});
export default SvgSquareLogo;
